import { ComponentChildren } from 'preact';
import { stringLiteralArray } from '../utils/UNSAFE_arrayUtils';
import { multiVariantStyles } from './themes/HeadingStyles.css';

export const headingElementTypes = stringLiteralArray(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']);

type ElementType = typeof headingElementTypes[number];

type HeadingProps = {
  /**
   * Specifies the heading tag
   */
  as: ElementType;

  /**
   * Specifies the font size and line height. The default value of this property is theme driven.
   */
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'inherit';

  /**
   * Specifies the header id
   */
  id?: string;

  /**
   * Specifies the children
   */
  children: ComponentChildren;
};

const headingsizeMap: { [headingType in ElementType]: string } = {
  h1: '2xl',
  h2: 'xl',
  h3: 'lg',
  h4: 'md',
  h5: 'sm',
  h6: 'xs'
};

export const sizeOptions = ['xs', 'sm', 'md', 'lg', 'xl', '2xl', 'inherit'];

export function Heading({ children, as, size, id }: HeadingProps) {
  const Component = as;
  //@ts-ignore
  size = size ?? headingsizeMap[Component];
  const classes = multiVariantStyles({ size });
  return (
    <Component className={classes} id={id}>
      {children}
    </Component>
  );
}
